/*
 *  return true if country code is US, otherwise false
 */

export function isUSCountryCode() {
  return document.getElementById('country-code')?.value === 'US';
}
